import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const themes = {
  default: 'default',
  lightBlue: 'light-blue',
};

const SasHtmlInjectionBlock = ({ html, theme = themes.default }) => {
  function createHtml() {
    return { __html: html };
  }

  return html ? (
    <div
      className={cn('sas-html-injection-block', {
        [`sas-html-injection-block_theme-${theme}`]: theme,
      })}
    >
      <div className="sas-html-injection-block__container">
        <div dangerouslySetInnerHTML={createHtml()} />
      </div>
    </div>
  ) : null;
};

SasHtmlInjectionBlock.propTypes = {
  html: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(themes)).isRequired,
};

export default SasHtmlInjectionBlock;
